import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { injectValuesIntoTemplate } from '../../utils/templates'
import '../BookingSummary/BookingSummary.css'
import './bookingPayment.css'

import PayPalForm from './PayPalForm'
import StripeForm from './StripeForm'

class BookingPayment extends Component {
  static propTypes = {
    business: PropTypes.object.isRequired,
    booking: PropTypes.object.isRequired,
    onPaymentComplete: PropTypes.func.isRequired,
    onPaymentDeclined: PropTypes.func.isRequired,
  }

  state = {
    loading: false,
    payKey: null,
  }

  getPaypalPaymentVariables() {
    const { business, booking } = this.props
    const service = business.services.find(s => s.id === booking.service.id)
    const duration = service.durations && service.durations.find(d => d.duration === booking.duration)

    return {
      businessId: business.id,
      payee: business.paypalEmail,
      amount: duration.price,
      currency: service.currency,
      description: service.name,
      requirePaypalShippingAddress: business.requirePaypalShippingAddress,
    }
  }

  getStripePaymentVariables() {
    const { business, booking } = this.props

    return {
      businessId: business.id,
      stripeAccount: business.stripeConnectAccount,
      serviceId: booking.service.id,
      duration: booking.duration,
      customerName: booking.customer.name,
      customerEmail: booking.customer.email,
      appointmentId: booking.id,
    }
  }

  renderPaymentError(){
    const { paymentError } = this.props
    if(!paymentError) {
      return null
    }
    console.error('paymentError', paymentError)

    return (
      <p className="payment-error">
        <strong>Payment was declined. Please try again.</strong>
        { paymentError.message && <span><br /><em>"{ paymentError.message }"</em></span> }
      </p>
    )
  }

  renderPaypalForm(service) {
    if (!service.requiresPaypalPayment) {
      return null
    }

    const { onPaymentComplete, onPaymentDeclined } = this.props

    return (
      <PayPalForm
        {...this.getPaypalPaymentVariables()}
        onPaymentComplete={onPaymentComplete}
        onPaymentDeclined={onPaymentDeclined}
      />
    )
  }

  renderStripeForm(service) {
    if (!service.requiresStripePayment) {
      return null
    }

    const { onPaymentComplete, onPaymentDeclined } = this.props

    return (
      <StripeForm
        {...this.getStripePaymentVariables()}
        onPaymentComplete={onPaymentComplete}
        onPaymentDeclined={onPaymentDeclined}
      />
    )
  }

  renderPaymentForms(service) {
    const paymentEnabled = service.requiresPaypalPayment || service.requiresStripePayment
    if (!paymentEnabled) {
      return null
    }

    return (
      <div className="payment-form">
        <h6>Payment required</h6>
        { this.renderPaypalForm(service) }
        { service.requiresPaypalPayment && service.requiresStripePayment && <h6 className="or">- or -</h6> }
        { this.renderStripeForm(service) }
      </div>
    )
  }

  getMessageHtml() {
    const { booking, business } = this.props
    const service = business.services.find(s => s.id === booking.service.id)

    const template = business.bookingTemplatesHtml["payment-screen"] || "Make a payment to confirm your booking"
    return injectValuesIntoTemplate(template, {
      service,
      booking,
      dateFormat: business.dateFormat,
    })
  }

  render() {
    const { business, booking } = this.props
    const service = business.services.find(s => s.id === booking.service.id)

    return (
      <div className="booking-summary">
        <div className="inner">
          <div className="booking-summary-content" dangerouslySetInnerHTML={{ __html: this.getMessageHtml() }} />
          { this.renderPaymentError() }
          { this.renderPaymentForms(service) }
        </div>
      </div>
    )
  }
}

export default BookingPayment
